import { Component, Input } from '@angular/core';

@Component({
  selector: 'mk-material-bar',
  template: `
  <div class="material-bar">
    <div class="bar" [style.background-color]="colorOne"></div>
    <div class="bar" [style.background-color]="colorTwo"></div>
    <div class="bar" [style.background-color]="colorThree"></div>
  </div>`,
  styles: [`.material-bar{position:relative;width:100%;height:4px;background-color:#fdba2c}.bar{content:"";display:inline;position:absolute;width:0;height:100%;left:50%;text-align:center}.bar:nth-child(1){-webkit-animation:3s linear infinite loading;animation:3s linear infinite loading}.bar:nth-child(2){-webkit-animation:3s linear 1s infinite loading;animation:3s linear 1s infinite loading}.bar:nth-child(3){-webkit-animation:3s linear 2s infinite loading;animation:3s linear 2s infinite loading}@-webkit-keyframes loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}@keyframes loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}`]
})
export class MaterialbarComponent {
  @Input() colorOne = '#da4733';
  @Input() colorTwo = '#3b78e7';
  @Input() colorThree = '#fdba2c';
}
